import React, { useEffect, useLayoutEffect, Fragment, useState } from "react";
import { useLocation } from "react-router-dom";
import Scrollspy from "react-scrollspy";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp, FiX, FiMenu } from "react-icons/fi";
import FooterTwo from "../component/footer/FooterTwo";
import Helmet from "../component/common/Helmet";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import logoXrai from "../assets/images/logo/xrailogo.png";
import "../css/BorderTable.css";
import {
  BorderPwTitle,
  ComentButton,
  FileInputFlex,
  FinalAddButton,
  FlexBox,
  FreeSizeBox,
  InputBackBox,
  InputBackBox2,
  InquiryBox,
  InquiryGroupBox,
  LockIcon,
  PwBackBox,
  PwButton,
  PwButton2,
  TableCategory,
} from "../css/BorderPageStyle";
import { useSetRecoilState } from "recoil";
import { apiKeyState } from "../atom/ApiKey";
import { apiProductsState } from "../atom/Products";
import { removeCookie } from "../util/Cookie";
import { TokenName } from "../util/Common";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import WysiwygInput from "../component/WysiwygInput";
import { IoIosUnlock } from "react-icons/io";
import { ListJoinState } from "../atom/BorderPage";

const SaveTextPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState("");
  const { data } = location.state;

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };
  useLayoutEffect(() => {
    const { hash } = location;
    if (hash) {
      const target = document.getElementById(hash.substring(1));
      if (target) {
        console.log(hash, target);
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [location]);

  const menuTrigger = () => {
    document.querySelector(".header-wrapper").classList.toggle("menu-open");
  };

  const closeMenuTrigger = () => {
    document.querySelector(".header-wrapper").classList.remove("menu-open");
  };

  useEffect(() => {
    const handleScroll = () => {
      var value = window.scrollY;
      if (value > 100) {
        document.querySelector(".header--fixed").classList.add("sticky");
      } else {
        document.querySelector(".header--fixed").classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    const elements = document.querySelectorAll(".has-droupdown > a");
    for (let i = 0; i < elements.length; i++) {
      elements[i].onclick = function () {
        this.parentElement.querySelector(".submenu").classList.toggle("active");
        this.classList.toggle("open");
      };
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const logo = {
    // width: "20%",
    width: `150px`,
  };
  const setApiKeys = useSetRecoilState(apiKeyState);
  const setPriducts = useSetRecoilState(apiProductsState);
  const [isToken, setToken] = useState(false);
  const setListJoinState = useSetRecoilState(ListJoinState);

  const haderLogout = () => {
    localStorage.clear();
    setApiKeys([]);
    setPriducts([]);
    setListJoinState([]);
    removeCookie(TokenName);
    history.push("/login");
  };
  const [isFocused, setIsFocused] = useState(false);

  return (
    <Fragment>
      <Helmet pageTitle="XRAI | (주)엑스알에이아이" />
      {/* Start Header Area  */}
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <a href="/">
                <img
                  className="logo-1"
                  style={logo}
                  src={logoXrai}
                  alt="Logo Images"
                />
                <img className="logo-2" src={logoXrai} alt="Logo Images" />
              </a>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy
                className="mainmenu"
                items={["home", "border", "contact"]}
                // currentClassName="is-current"
                offset={-200}
              >
                <li>
                  <a
                    style={{
                      cursor: `pointer`,
                    }}
                    onClick={() => history.push("/")}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a href="/#company">Company</a>
                </li>
                <li>
                  <a href="/#solution">Solution</a>
                </li>
                <li>
                  <a href="/#portfolio">Portfolio</a>
                </li>
                <li>
                  <a
                    style={{
                      color: `#ffc20e`,
                      cursor: `pointer`,
                    }}
                  >
                    Contact
                    <hr
                      color={`#ffc20e`}
                      style={{
                        height: `4px`,
                      }}
                    />
                  </a>
                </li>
                <li>
                  {isToken === true ? (
                    <a href="login">Login</a>
                  ) : (
                    <a
                      style={{
                        cursor: `pointer`,
                      }}
                      onClick={() => haderLogout()}
                    >
                      Logout
                    </a>
                  )}
                </li>
              </Scrollspy>
            </nav>
            {/* <div className="header-btn">
              <a
                className="rn-btn"
                href="https://themeforest.net/checkout/from_item/25457315?license=regular"
              >
                <span>buy now</span>
              </a>
            </div> */}
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={menuTrigger} className="menutrigger text-white">
                <FiMenu />
              </span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={closeMenuTrigger} className="closeTrigger">
                <FiX />
              </span>
            </div>
          </div>
        </div>
      </header>

      <div className="about-area ptb--120 bg_color--5">
        <div className="about-wrapper">
          <div
            className="container"
            style={{
              display: `flex`,
              alignItems: `center`,

              flexDirection: `column`,
            }}
          >
            <div
              style={{
                fontWeight: `800`,
                fontSize: `36px`,
                marginTop: `26px`,
                marginBottom: `26px`,
                borderBottom: `2px solid #ffc20e`,
              }}
            >
              도입문의
            </div>
            <div
              style={{
                width: `100%`,
                padding: `20px`,
                border: `1px solid gray`,
                borderRadius: `16px`,
                backgroundColor: `white`,
              }}
            >
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  borderBottom: `1px solid gray`,
                  paddingTop: `20px`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      width: `100px`,
                    }}
                  >
                    문의 유형
                  </div>
                  <div>
                    <select
                      value={selectedValue}
                      onChange={handleChange}
                      style={{
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        width: `290px`,
                        display: `flex`,
                        justifyContent: `center`,
                        alignItems: `center`,
                        textAlign: "center",
                        textAlignLast: "center",
                        backgroundColor: `white`,
                      }}
                    >
                      <option value="">선택하세요</option>
                      <option value="option1">옵션 1</option>
                      <option value="option2">옵션 2</option>
                      <option value="option3">옵션 3</option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                    width: `100%`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                    }}
                  >
                    문의 제목
                  </div>
                  <div style={{ flex: 1 }}>
                    <input
                      style={{
                        backgroundColor: `white`,
                        width: `100%`,
                        borderRadius: `4px`,
                      }}
                      type="text"
                    ></input>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                    width: `100%`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                    }}
                  >
                    회사명
                  </div>
                  <div style={{ flex: 1 }}>
                    <input
                      style={{
                        width: `100%`,
                        borderRadius: `4px`,
                        backgroundColor: `white`,
                      }}
                      type="text"
                    ></input>
                  </div>
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                      display: `flex`,
                      justifyContent: `end`,
                      alignItems: `center`,
                    }}
                  >
                    담당자
                  </div>
                  <div style={{ flex: 1 }}>
                    <input
                      style={{
                        width: `100%`,
                        borderRadius: `4px`,
                        backgroundColor: `white`,
                      }}
                      type="text"
                    ></input>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `center`,
                    width: `100%`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                    }}
                  >
                    이메일
                  </div>
                  <div style={{ flex: 1 }}>
                    <input
                      style={{
                        width: `100%`,
                        borderRadius: `4px`,
                        backgroundColor: `white`,
                      }}
                      type="text"
                    ></input>
                  </div>
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                      display: `flex`,
                      justifyContent: `end`,
                      alignItems: `center`,
                    }}
                  >
                    연락처
                  </div>
                  <div style={{ flex: 1 }}>
                    <input
                      style={{
                        width: `100%`,
                        borderRadius: `4px`,
                        backgroundColor: `white`,
                      }}
                      type="text"
                    ></input>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `flex-start`,
                    width: `100%`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                      display: `flex`,
                      justifyContent: `start`,
                      alignItems: `start`,
                    }}
                  >
                    문의 내용
                  </div>

                  <div style={{ flex: 1 }}>
                    <WysiwygInput />
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    alignItems: `flex-start`,
                    width: `100%`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `600`,
                      fontSize: `24px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                      display: `flex`,
                      justifyContent: `start`,
                      alignItems: `start`,
                    }}
                  >
                    첨부 파일
                  </div>

                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: `flex`,
                        alignItems: `center`,
                        marginBottom: `10px`,
                        color: `gray`,
                        justifyContent: `space-between`,
                        marginTop: `6px`,
                      }}
                    >
                      <button
                        style={{
                          padding: "5px 10px",
                        }}
                      >
                        내 PC
                      </button>
                      <div>파일 용량 / 개 수</div>
                    </div>
                    <div
                      style={{
                        display: `flex`,
                        minHeight: `150px`,
                        backgroundColor: `white`,
                        // alignItems: `center`,
                      }}
                    >
                      <div
                        style={{
                          display: `flex`,
                          width: `100%`,
                          border: `1px solid black`,
                        }}
                      >
                        {/* <FileInputFlex $flex={2}>ds</FileInputFlex>
                      <FileInputFlex $flex={2}>ds</FileInputFlex>
                      <FileInputFlex $flex={2}>ds</FileInputFlex>
                      <FileInputFlex $flex={2}>ds</FileInputFlex> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  width: `100%`,
                  paddingBottom: `20px`,
                  paddingTop: `20px`,
                  borderBottom: `1px solid gray`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    width: `100%`,
                    flexDirection: `column`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `500`,
                      fontSize: `16px`,
                      marginRight: `32px`,
                      whiteSpace: "nowrap",
                      width: `100px`,
                      marginBottom: `10px`,
                      color: `gray`,
                    }}
                  >
                    개인정보 수집 및 동의 (필수)
                  </div>
                  <div style={{ flex: 1 }}>
                    <textarea
                      readOnly
                      style={{
                        backgroundColor: `white`,
                        width: `100%`,
                        borderRadius: `4px`,
                        height: `200px`,
                      }}
                      type="text"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  justifyContent: `center`,
                  alignItems: `center`,
                  marginTop: `20px`,
                }}
              >
                <div
                  style={{
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                  }}
                >
                  <div
                    style={{
                      fontWeight: `700`,
                      fontSize: `16px`,
                    }}
                  >
                    동의합니다
                  </div>
                  <input
                    style={{
                      marginLeft: `10px`,
                      width: `20px`,
                    }}
                    type="checkbox"
                  ></input>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: `flex`,
                    justifyContent: `center`,
                    alignItems: `center`,
                    marginTop: `20px`,
                    marginBottom: `20px`,
                  }}
                >
                  <InputBackBox2 isFocused={isFocused}>
                    <IoIosUnlock
                      color="gray"
                      size={`30px`}
                      style={{
                        marginRight: `5px`,
                        marginLeft: `5px`,
                      }}
                    />
                    <input
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                      style={{
                        width: "100%",
                        border: "none",
                        outline: "none",
                        fontSize: "16px",
                      }}
                      type="password"
                    ></input>
                  </InputBackBox2>
                </div>
              </div>
              <div
                style={{
                  display: `flex`,
                  justifyContent: `center`,
                  alignItems: `center`,
                }}
              >
                <FinalAddButton>등록하기</FinalAddButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterTwo />
      {/* End Footer Style  */}
      {/* Start Back To Top */}
      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>
      {/* End Back To Top */}
    </Fragment>
  );
};

export default SaveTextPage;
